import type { TextFieldProps } from 'opensolar-ui'

type TariffInputOptions = Partial<Omit<TextFieldProps, 'label'>> & { label?: false; disableLabel?: boolean }

/**
 * Shared options for tariff pricing inputs (NumberInput, SelectInput, TextInput).
 * Uses MUI InputProps for white background instead of CSS overrides.
 */
export const tariffInputOptions = (theme: object, overrides?: TariffInputOptions): TariffInputOptions => ({
  margin: 'none' as const,
  label: false,
  disableLabel: true,
  helperText: false,
  InputLabelProps: { shrink: false },
  InputProps: {
    style: { backgroundColor: (theme as { white?: string }).white ?? '#fff' },
  },
  ...overrides,
})

/** Type-safe wrapper for passing to NumberInput/SelectInput/TextInput options prop. */
export const getTariffInputOptions = (
  theme: object,
  overrides?: TariffInputOptions
): Partial<Omit<TextFieldProps, 'label'>> =>
  tariffInputOptions(theme, overrides) as Partial<Omit<TextFieldProps, 'label'>>
